import * as React from 'react';
import { useSelector } from 'react-redux';
import { PageBody, PageContent } from '../../../../components/page-components/_index';
import { IApplicationState } from '../../../../store/IApplicationState';

export const DataSettingsScene = () => {

    const transportState = useSelector((state : IApplicationState) => state.transportation);
    
    return <PageContent pageName={'DataSettings'}>
            <PageBody>
                <div className="row justify-content-between">
                    <div className="col-4">
                        <h2>Transportation Settings</h2>
                    </div>
                    <div className="col-4 text-right">
                        <h2>Cache Version: [{ transportState.cacheVersion }]</h2>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>What?</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Saved Planning Tab</td>
                                    <td>{ transportState.selectedPlanningTab ? transportState.selectedPlanningTab : 'Nothing to Report' }</td>
                                </tr>
                                <tr>
                                    <td>Saved Shipments Tab</td>
                                    <td>{ transportState.selectedShipmentTab ? transportState.selectedShipmentTab : 'Nothing to Report' }</td>
                                </tr>
                                <tr>
                                    <td>Saved Fleet Tab</td>
                                    <td>{ transportState.selectedFleetTab ? transportState.selectedFleetTab : 'Nothing to Report' }</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>                        
                </div>
            </PageBody>
        </PageContent>;
    
};
